<template>
<div class="sections-container">
  <div class="header-sections">
    <span class="title-section">Extras</span>

    <div class="filter-colum-sections">
      <v-text-field
          style="width: 320px;"
          type="text"
          placeholder="Buscar"
          v-model="currentSearch"
          color="#222222"
          clearable
          @click:clear="clearSearch"
          variant="underlined">
          <template v-slot:append-inner>
            <v-icon color="#222222" icon="mdi-magnify" size="small"/>
          </template>
        </v-text-field>
    </div>
  </div>

  <div class="select-filter-container">
    <div></div>
    <div class="autocomplete-container">
      <span class="title-filter">POS:</span>
      <v-select
          v-model="filterSelected"
          :items="filterData"
          item-title="label"
          item-value="value"
          density="compact"
          hide-details="auto"
          variant="solo"
          class="no-bg"/>
    </div>
  </div>

  <extras-table :extras="dataResponse" @refreshList="getList"/>

  <div v-if="totalPages > page"
    class="container-btn-more">
    <button class="btn-text" @click="moreData">
      + Mostrar más
    </button>
  </div>

  <div class="fab-button" @click="addModal">
    <v-icon icon="mdi-plus"></v-icon>
  </div>

  <add-edit-extras ref="addEditModal" @refreshList="getList"/>
</div>
</template>
<script>
import ExtrasTable from '../tables/ExtrasTable.vue'
import terminalsApi from '@/api/terminalsApi'
import AddEditExtras from '../forms/AddEditExtras.vue'
import extrasApi from '@/api/extrasApi'
export default {
  name: 'CommerciaVueExtras',
  components: {
    ExtrasTable,
    AddEditExtras
  },
  data () {
    return {
      business: this.$store.getters.business,
      currentSearch: '',
      filterSelected: 'Todos',
      filterData: [{ value: 'Todos', label: 'Todos' }],
      dataResponse: [],
      page: 1,
      totalPages: 0
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    if (this.user?.role === 'finance') {
      this.$router.push({ name: 'dashboard' })
    }
    this.getPos()
    this.getList()
  },
  watch: {
    currentSearch (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    filterSelected (newVal, oldVal) {
      this.page = 1
      this.getList()
    }
  },
  methods: {
    moreData () {
      this.page += 1
      this.getList()
    },
    clearSearch () {
      this.page = 1
      this.currentSearch = ''
      this.getList()
    },
    addModal () {
      this.$refs.addEditModal.add()
    },
    async getPos () {
      const listPos = await terminalsApi.list(this.business._id, '')
      console.log(listPos)
      for (const item of listPos) {
        this.filterData.push({ value: item._id, label: item.name })
      }
    },
    async getList () {
      if (this.filterSelected === 'Todos') {
        const dataRes = await extrasApi.listByBussines(
          this.busines._id,
          this.currentSearch,
          this.page)

        this.dataResponse = this.page === 1
          ? (dataRes.extras || [])
          : [...this.dataResponse, ...(dataRes.extras || [])]
        this.totalPages = dataRes.totalPages || 0

        // this.dataResponse = await extrasApi.listByBussines(this.busines._id, this.currentSearch, this.page)
      } else {
        const dataRes = await extrasApi.listByPos(
          this.filterSelected,
          this.currentSearch,
          this.page)

        this.dataResponse = this.page === 1
          ? (dataRes.extras || [])
          : [...this.dataResponse, ...(dataRes.extras || [])]
        this.totalPages = dataRes.totalPages || 0
      }
    }
  }
}
</script>

<style scoped>
@import '@/assets/styles/sections.css';
@import '@/assets/styles/inputs.css';
</style>
